import { Box, Typography } from "@mui/material";

export function OptionBox({ title, content, width }) {
    return <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "space-between", alignItems: "start", height: "100%",width }}>
        <Typography sx={{ color: "#2C358A", fontWeight: "bold", fontSize: "14px", fontFamily: "Figtree" }}>{title}</Typography>
       <Box sx={{width:"100%",fontFamily:"Figtree",fontSize:"16px"}}> {content}</Box>
    </Box>
}